import store from "../../store";

// Internals Imports
import { WORKFLOW } from "../../constants";

import {
  createWorkFlowService,
  getAllWorkFlowsService,
  getWorkFlowAttributesService,
  getWorkFlowDetailsService,
  updateWorkFlowRuleService,
} from "./workFlowService";

import {
  getPriceListsService,
  getProducts,
} from "../PricebooksActions/pricebooksService";
import { fetchAllUsers } from "../PipelineActions/pipelineServices";
import { fetchUserGroupsService } from "../UserActions/userService";

import {
  generateFormFiled,
  generateWrkFlowMetaData,
  parsePricelistData,
  parseWrkFlowAttributes,
  parseWrkFlowData,
} from "./workFlowMethods";

// Destructuring
const { FORM_FIELD_DATA } = WORKFLOW;

export const getAllWorkFlows = () => dispatch =>
  new Promise((resolve, reject) => {
    getAllWorkFlowsService()
      .then(response => {
        dispatch({
          type: "UPDATE_WORKFLOW_LIST",
          payload: response,
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const createWorkFlow = payload => () =>
  new Promise((resolve, reject) => {
    createWorkFlowService(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getInitData = id => async dispatch => {
  try {
    const pricelists = await getPriceListsService();
    const products = await getProducts();
    const attributes = await getWorkFlowAttributesService(id);
    const workFlowDetails = await getWorkFlowDetailsService(id);
    const users = await fetchAllUsers();
    const userGroups = await fetchUserGroupsService();

    Promise.all([
      pricelists,
      attributes,
      workFlowDetails,
      users,
      products,
      userGroups,
    ])
      .then(response => {
        const pricelist = parsePricelistData(response[0].PriceListPage.plists);
        const metaData = generateWrkFlowMetaData(response);
        const attributesData = parseWrkFlowAttributes(response[1]);
        const workflowData = parseWrkFlowData(response[2], metaData);
        const formFields = generateFormFiled(
          response[2],
          pricelist,
          products,
          metaData,
        );
        const payload = {
          attributes: attributesData,
          formFields,
          metaData,
          pricelists: pricelist,
          products,
          users: response[3].users,
          userGroups: response[5].Usergroups,
          workflowData,
        };
        dispatch({
          type: "REACTION_WORKFLOW_INIT_DATA",
          payload,
        });
      })
      .catch(error => {
        console.debug(`workFlowActions => getInitData" => ${error}`);
        throw error;
      });
    return null;
  } catch (error) {
    throw error;
  }
};

export const updateWorkFlowData = (key, value, index) => dispatch => {
  const reduxState = store.getState();
  const { formFields } = reduxState.WorkFlowStore;
  const updatedFormFields = [...formFields];

  //* Make the rule dirty, so only the changed values are added to API call
  updatedFormFields[index].isDirty = true;
  updatedFormFields[index][key] =
    typeof value === "string"
      ? value
      : { ...updatedFormFields[index][key], ...value };
  dispatch({
    type: "UPDATE_WORKFLOW_FORMFIELDS",
    payload: updatedFormFields,
  });
};

export const updateWorkFlowRule = (id, payload) => dispatch =>
  new Promise((resolve, reject) => {
    //* Filter out the dirty rule(s) for the API
    const dirtyFormFields = payload.filter(rule => rule.isDirty);
    if (dirtyFormFields.length > 0) {
      updateWorkFlowRuleService(id, dirtyFormFields)
        .then(response => {
          //* Replace the updated rule from API into redux
          let index = 0;
          const updatedResponse = payload.map(rule => {
            if (rule.isDirty) {
              rule = response[index];
              index += 1;
            }
            delete rule.isDirty;
            return rule;
          });
          //* Parse the API JSON to FrontEnd Structure
          const { metaData, pricelist, products } =
            store.getState().WorkFlowStore;
          const workflowData = parseWrkFlowData(updatedResponse, metaData);
          const formFields = generateFormFiled(
            workflowData,
            pricelist,
            products,
            metaData,
          );
          dispatch({
            type: "UPDATE_WORKFLOW_RULE",
            payload: {
              workflowData,
              formFields,
            },
          });
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    } else {
      resolve(true);
    }
  });

export const nukeFormFiledData = () => dispatch => {
  const reduxState = store.getState();
  const { formFields } = reduxState.WorkFlowStore;
  const payload = [
    {
      id: formFields[0].id,
      ...JSON.parse(JSON.stringify(FORM_FIELD_DATA)),
    },
  ];
  dispatch({
    type: "NUKE_WORKFLOW_FORMFIELDS",
    payload,
  });
};
